module.exports = __webpack_public_path__ + "img/transform_polluted_beach_splash.0236fc6d.jpg";